<template>
    <v-row v-if="account != null" class="col-account  mx-0">

        <v-col cols="12" class="px-0 pb-1 pt-1">
            <v-icon class="mb-2">mdi-account</v-icon>
            <b style="font-size:19px;">{{ account.name }}</b>
        </v-col>

        <v-col cols="12" class="mb-2 grey darken-4" style="border:2px solid grey; border-radius:4px;">

            <v-btn v-if="!account.stateAccount" x-small fab class="float-right btn-yellow-pirate" 
                    @click="startTransaction(account.walletMain)"
                    :disabled="account.walletMain.amountUnity <= 0">
                <v-icon>mdi-arrow-right</v-icon>
            </v-btn>

            <b><small>Compte courant n° {{ account.walletMain.uid }}</small></b>

            <div class="font-led mt-1" style="font-size:17px;">
                <span class="blue--text">
                {{ account.walletMain.amountUnity.toFixed(4) }} ù
                </span>
                =
                <span class="yellow-pirate">
                {{ convertUnityMony(account.walletMain.amountUnity).toFixed(4) }} PRT
                </span>
                <!-- {{ account.walletMain.transactions }} -->
            </div>
            <div class="py-3" style="">
                <ChartWalletTuto :height="150"
                                :walletMain="account.walletMain" 
                                :walletDeposit="account.walletDeposit" 
                                :monyConvertValue="monyConvertValue"
                                :inPRT="false">
                </ChartWalletTuto>
            </div>

        </v-col>


        <v-col cols="12" class="grey darken-4" style="border:2px solid grey">
            <div>
                <v-btn v-if="!account.stateAccount" x-small fab class="float-right btn-yellow-pirate" 
                    @click="startTransaction(account.walletDeposit)"
                    :disabled="account.walletMain.amountUnity <= 0">
                <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
                <b><small>Compte de dépôt n°{{ account.walletDeposit.uid }}</small></b>
            </div>
            <div  class="font-led mt-1 yellow-pirate" style="font-size:17px;">
                {{ account.walletDeposit.amountMony.toFixed(4) }} PRT
            </div>
            <div class="py-3 mx-auto" style="max-width: 60%; margin-top:-40px;">
                <ChartSparkline :walletDeposit="account.walletDeposit" 
                                :monyConvertValue="monyConvertValue"
                                :inPRT="true">
                </ChartSparkline>
                <!-- {{ account.walletMain.transactions }} -->
            </div>
        </v-col>

    </v-row>
</template>


<script>

//import axios from 'axios'
//import router from '../router/router'
import core from '../../plugins/core.js'
import ChartSparkline from '../home/ChartSparkline.vue';
import ChartWalletTuto from '../../components/charts/ChartWalletTuto.vue';

//import Post from '@/components/Post.vue'
// const config = require('../../config/' + process.env.NODE_ENV)

export default {
    name: 'walletsim',
    props: [ 'account', 'monyConvertValue', 'startTransaction' ],
    components: { ChartSparkline, ChartWalletTuto },
    data: () => ({
    }),
    async mounted(){
        
    },
    methods: {
        convertUnityMony(amount){
        return core.convertUnityMony(amount, this.monyConvertValue)
        },
        baseUrl(){ return core.baseUrl() },
    },
    computed: {
        
        
    }
}
</script>
